<template>
  <div class="localcard" @touchmove.stop v-touchmove>
    <Fields
      v-for="item in cardList"
      :key="item.id"
      :cardInfo="item"
      @select="currentSelectedCard = item"
      :isActive="currentSelectedCard.id === item.id"
      @deletecard="$emit('deletecard', item)"
      :vaultManager="vaultManager"
      ref="fieldsList"
    />
  </div>
</template>
<script>
import Fields from './fields/index.vue'
export default {
  props: {
    cardList: {
      type: Array,
      default: () => [],
    },
    vaultManager: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  components: {
    Fields,
  },
  watch: {
    cardList(newVal, oldVal) {
      if (newVal.length > 0) {
        this.currentSelectedCard = newVal[0]
      }
    },
  },

  data() {
    return {
      currentSelectedCard: this.cardList[0],
    }
  },
  methods: {
    async validate() {
      const fieldsIndex = this.cardList.findIndex((item) => item.id === this.currentSelectedCard.id)
      const fieldsRef = this.$refs.fieldsList[fieldsIndex]
      return await fieldsRef.validate()
    },
  },
}
</script>
<style lang="less" scoped>
.localcard {
  padding: 0 16px;
  overflow-y: auto;
}
</style>
